import React from 'react';
import { ServerIcon, TrendingUpIcon, PuzzleIcon, LifeBuoyIcon } from 'lucide-react';
import { supportColumns } from '../data/homepage';
const icons = {
  upkeep: ServerIcon,
  improving: TrendingUpIcon,
  grow: PuzzleIcon
} as const;
export function SupportSection() {
  return <section id="support" aria-labelledby="support-title" className="on-dark bg-ink text-white" data-id="element-235" data-mp="186j4bevp3fvb">
      <div className="mx-auto max-w-[1280px] px-5 py-12 md:px-8 md:py-16 lg:py-20" data-id="element-236" data-mp="1mv6yphtt1jjo">
        <div className="grid gap-5 lg:grid-cols-2 lg:gap-20" data-id="element-237" data-mp="1mx06j0g5m9t9">
          <h2 id="support-title" className="max-w-[560px] text-[30px] font-extrabold leading-[1.12] md:text-[42px]" data-id="element-238" data-mp="1hvatxgda9o32">
            Launch is the start. We stay on the job.
          </h2>
          <p className="max-w-[560px] text-[17px] leading-[1.6] text-white/80 lg:pt-2" data-id="element-239" data-mp="1rs5ojo6fr4c2">
            Send the changes you need. Our team keeps your website current, your marketing moving, and your
            systems working together.
          </p>
        </div>

        <ul className="mt-10 grid border-t border-ink-line md:grid-cols-3 md:divide-x md:divide-ink-line" data-id="element-240" data-mp="17uafbx9p5led">
          {supportColumns.map(col => {
          const Icon = icons[col.id as keyof typeof icons];
          return <li key={col.id} className="border-b border-ink-line py-7 md:border-b-0 md:px-8 md:py-9 md:first:pl-0 md:last:pr-0" data-id="element-241" data-mp="1hq3w5sug811y">
                <Icon className="h-6 w-6 text-brand-green" strokeWidth={1.75} aria-hidden data-id="element-242" data-mp="1rggk7v1h2ccu" />
                <h3 className="mt-4 text-[20px] font-bold leading-snug" data-id="element-243" data-mp="1vhiia8jnkid8">{col.title}</h3>
                <p className="mt-2 max-w-[340px] text-[16px] leading-[1.6] text-white/75" data-id="element-244" data-mp="20iy5a65e4yy9">{col.body}</p>
              </li>;
        })}
        </ul>

        <div id="pricing" className="grid gap-6 border-t border-ink-line pt-8 md:mt-2 lg:grid-cols-[auto_1fr] lg:items-end lg:gap-16" data-id="element-245" data-mp="63vjaifjvz03">
          <div data-id="element-246" data-mp="b26vv0x8cnm0">
            <p className="flex items-center gap-2.5 text-[16px] font-semibold text-white/85" data-id="element-247" data-mp="b3rogkzzhwh8">
              <LifeBuoyIcon className="h-5 w-5 shrink-0 text-brand-orange" aria-hidden data-id="element-248" data-mp="3324abfo14lc" />
              Real people by phone, email, and support ticket.
            </p>
            <p className="mt-3 text-[26px] font-extrabold leading-tight md:text-[32px]" data-id="element-249" data-mp="d0zs4xtm4zdf">
              A clear scope. <span className="text-brand-orange" data-id="element-250" data-mp="80u7i1lrgd4u">A tailored monthly plan.</span>
            </p>
          </div>
          <p className="max-w-[420px] text-[14px] leading-[1.6] text-white/70 lg:justify-self-end" data-id="element-251" data-mp="m0d6o4wlge50">
            Ad spend and third-party costs are separate. Larger new projects are scoped before work begins.
          </p>
        </div>
      </div>
    </section>;
}